import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "main-header" }
const _hoisted_2 = {
  key: 0,
  class: "main-header-menu"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Image = _resolveComponent("Image")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DropdownMenu = _resolveComponent("DropdownMenu")!
  const _component_UserInfoDropdownMenu = _resolveComponent("UserInfoDropdownMenu")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _createVNode(_component_Image, {
            class: "main-header-logo",
            src: "main/header-logo",
            extension: "svg"
          })
        ]),
        _: 1
      }),
      (_ctx.showMenu)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_Image, {
              class: _normalizeClass(`menu-icon ${_ctx.isOpenLanguageMenu && 'is-active'}`),
              src: "icons/ic_globe",
              extension: "svg",
              onClick: _ctx.toggleLanguageMenu
            }, null, 8, ["class", "onClick"]),
            (_ctx.isLogin)
              ? (_openBlock(), _createBlock(_component_Image, {
                  key: 0,
                  class: _normalizeClass(`menu-icon ${_ctx.isOpenAccountMenu && 'is-active'}`),
                  src: "icons/ic_user_account",
                  extension: "svg",
                  onClick: _ctx.toggleAccountMenu
                }, null, 8, ["class", "onClick"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isOpenLanguageMenu)
      ? (_openBlock(), _createBlock(_component_DropdownMenu, {
          key: 0,
          ref: "languageMenuRef",
          "selected-value": _ctx.selectedLanguage,
          class: "header-menu",
          items: _ctx.languageDropdownItems,
          onClick: _ctx.onClickLanguage
        }, null, 8, ["selected-value", "items", "onClick"]))
      : _createCommentVNode("", true),
    (_ctx.isOpenAccountMenu)
      ? (_openBlock(), _createBlock(_component_UserInfoDropdownMenu, {
          key: 1,
          "is-portal": "",
          "preferred-user-name": _ctx.homeOwnerInfo.id,
          onClick: _ctx.onClickAccountMenu,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOpenAccountMenu = false))
        }, null, 8, ["preferred-user-name", "onClick"]))
      : _createCommentVNode("", true)
  ], 64))
}